import { useSelector } from 'react-redux';
import { Chip, Spacer, Text } from '@vinted/web-ui';
import HorizontalScrollArea from 'components/HorizontalScrollArea';
import SeparatedList from 'components/SeparatedList';
import useTranslate from 'hooks/useTranslate';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { UserItemsFilterType } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const UserItemsFilters = _ref => {
  let {
    selectedFilter,
    onFilterClick
  } = _ref;
  const closetFilteringAbTest = useSelector(getAbTestByName('closet_filtering'));
  const isClosetFilteringEnabled = useSelector(getIsFeatureSwitchEnabled('closet_filtering_web'));
  const translate = useTranslate();

  const onClick = filter => () => {
    onFilterClick(filter);
  };

  const renderViewSelfFilterList = () => {
    return /*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Medium
      }),
      children: [/*#__PURE__*/_jsx(Chip, {
        activated: selectedFilter === UserItemsFilterType.Active,
        testId: "closet-items-filters-active",
        text: translate('profile.item_filters.active'),
        textType: Text.Type.Subtitle,
        onClick: onClick(UserItemsFilterType.Active)
      }), /*#__PURE__*/_jsx(Chip, {
        activated: selectedFilter === UserItemsFilterType.Reserved,
        testId: "closet-items-filters-reserved",
        text: translate('profile.item_filters.reserved'),
        textType: Text.Type.Subtitle,
        onClick: onClick(UserItemsFilterType.Reserved)
      }), /*#__PURE__*/_jsx(Chip, {
        activated: selectedFilter === UserItemsFilterType.Hidden,
        testId: "closet-items-filters-hidden",
        text: translate('profile.item_filters.hidden'),
        textType: Text.Type.Subtitle,
        onClick: onClick(UserItemsFilterType.Hidden)
      }), /*#__PURE__*/_jsx(Chip, {
        activated: selectedFilter === UserItemsFilterType.Draft,
        testId: "closet-items-filters-drafts",
        text: translate('profile.item_filters.drafts'),
        textType: Text.Type.Subtitle,
        onClick: onClick(UserItemsFilterType.Draft)
      }), /*#__PURE__*/_jsx(Chip, {
        activated: selectedFilter === UserItemsFilterType.Sold,
        testId: "closet-items-filters-sold",
        text: translate('profile.item_filters.sold'),
        textType: Text.Type.Subtitle,
        onClick: onClick(UserItemsFilterType.Sold)
      })]
    });
  };

  if ((closetFilteringAbTest === null || closetFilteringAbTest === void 0 ? void 0 : closetFilteringAbTest.variant) !== 'on' || !isClosetFilteringEnabled) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "u-phones-only",
      children: /*#__PURE__*/_jsx(Spacer, {})
    }), /*#__PURE__*/_jsx(HorizontalScrollArea, {
      showControls: false,
      disableIosSmoothScroll: true,
      children: /*#__PURE__*/_jsx("div", {
        className: "u-flexbox",
        children: renderViewSelfFilterList()
      })
    })]
  });
};

export default UserItemsFilters;